import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  loadSector,
  loadSeats,
  updateSector,
  createSeats,
  updateSeats
} from '~/state/modules/planimetry'
import { loadEvent } from '~/state/modules/events'
import { PaperContainer } from '~/views/shared'
import { CircularProgress, Typography } from '@material-ui/core'
import { SectorForm } from '../SectorForm'
import { ROUTES } from '~/views/routes'
import { SEATS_STATUS, PositionDescriptor, SeatStatus } from 'config/constants'
import { updateSeatsGrid } from '../SeatsDistribution/SeatSettings/lib/utils'
import history from '~/config/history'
import { showSnackbarError, showSnackbarSuccess } from 'views/utils/snackbar'
import { cleanHexColor } from 'views/utils/functions'

export const SectorUpdatePage = ({ match, onSuccess }) => {
  const {
    sector,
    pendingSector,
    pendingSeats,
    pendingUpdateSector,
    seats,
    pendingCreateSeats,
    pendingUpdateSeats
  } = useSelector((state) => state.planimetry)
  const { event } = useSelector((state) => state.events)
  const { eventId, layoutId, sectorId } = match.params
  const hasSold = seats?.some(
    (seat) =>
      seat.status === SeatStatus.Sold || seat.status === SeatStatus.Reserved
  )

  const dispatch = useDispatch()

  const createSeatsPayload = (seats, newRows, newColumns) => {
    const updatedSeats = updateSeatsGrid(newRows, newColumns, seats).map(
      (seat) => ({
        Column: seat.column,
        Row: seat.row,
        IsSeat: true,
        Status: SEATS_STATUS[seat.status],
        Id: seat.id || null
      })
    )
    return {
      SectorId: sectorId,
      Column: newColumns,
      Row: newRows,
      Seats: updatedSeats
    }
  }

  const refreshSeats = async (newRows, newColumns) => {
    const payload = createSeatsPayload(seats, newRows, newColumns)
    const action = sector.Capacity === 0 ? createSeats : updateSeats
    await dispatch(action(payload))
  }

  const handleSubmit = async (values, { setSubmitting }) => {
    const { Column: newColumn, Row: newRow } = values
    try {
      setSubmitting(true)

      if (newColumn !== sector.Column || newRow !== sector.Row) {
        await refreshSeats(newRow, newColumn)
      }
      await dispatch(updateSector(values))

      onSuccess(eventId, layoutId)
      showSnackbarSuccess('Sector Actualizado!')
    } catch (error) {
      showSnackbarError(error)
    } finally {
      setSubmitting(false)
    }
  }

  const values = {
    SectorId: sectorId,
    SectorName: sector?.Name || '',
    Column: sector?.Column || '',
    ColumnDescriptor: sector?.ColumnDescriptor || PositionDescriptor.Numeric,
    Row: sector?.Row || '',
    RowDescriptor: sector?.RowDescriptor || PositionDescriptor.Numeric,
    ImageId: sector?.ImageId || '',
    ImageFile: sector?.ImageCdnUrl || null,
    LayoutId: layoutId,
    Color: cleanHexColor(sector?.Color)
  }

  useEffect(() => {
    async function fetchData() {
      await dispatch(loadEvent(eventId))
      await dispatch(loadSector(sectorId))
      await dispatch(loadSeats(sectorId))
    }

    fetchData()
    // eslint-disable-next-line
  }, [])

  return (
    <>
      {event && (
        <Typography variant='h6' style={{ paddingInline: 8, paddingBottom: 8 }}>
          {`${event?.Title} (${event?.Id})`}{' '}
        </Typography>
      )}
      <PaperContainer title='Actualización de Sector'>
        {pendingSector || pendingSeats ? (
          <div
            style={{ display: 'flex', alignItems: 'center', margin: '1rem' }}>
            <CircularProgress size={24} style={{ marginRight: '1rem' }} />
            <Typography>Cargando...</Typography>
          </div>
        ) : (
          <SectorForm
            values={values}
            actionText='Actualizar'
            handleSubmit={handleSubmit}
            actionPending={
              pendingUpdateSector ||
              pendingCreateSeats ||
              pendingUpdateSeats ||
              pendingSeats
            }
            hasSold={hasSold}
            onCancel={() =>
              history.push(
                ROUTES.ADMIN.EVENTS.SECTORS.INDEX.replace(
                  ':eventId',
                  eventId
                ).replace(':layoutId', layoutId)
              )
            }
          />
        )}
      </PaperContainer>
    </>
  )
}

export default SectorUpdatePage
